import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AlertService } from '../../commons/services/alert.service';
import { environment } from '../../../environments/environment';
// import { MIN_LENGTH_VALIDATOR } from '@angular/forms/src/directives/validators';
// import { loadElement } from '@angular/core/src/render3/instructions';
declare let WacomGSS_SignatureSDK;

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.css']
})
export class SignaturePadComponent implements OnInit {

  isClicked: Boolean = false;
  @Input() bon;

  @Output() close = new EventEmitter<any>();
  @Output() validFunction = new EventEmitter<any>();

  @ViewChild('msg') msg;
  @ViewChild('formEdit', {static : true}) formEdit;
  wgssSignatureSDK;
  doc = {};
  ctx;
  canvas;
  @Input() isBAP: Boolean;
  @Input() listBon: any[] = [];
  @Input() isTiketPesee: Boolean;

  constructor(public common: CommonService, private modalService: BsModalService, protected alert: AlertService) { }

  ngOnInit() {
    console.log('PAD', this.bon, this.isBAP);
    this.wgssSignatureSDK = new WacomGSS_SignatureSDK(this.onDetectRunning, 8000);
    this.common.openModal(this.modalService, this.formEdit, true);
    const ctrl = this;
    setTimeout(function () {
      ctrl.captureSignature();
    }, 1500);
  }

  /*timedDetect() 
  {
    if (this.wgssSignatureSDK && this.wgssSignatureSDK.running) 
    {
      console.log("timedDetect - Signature SDK Service detected");
    } 
    else 
    {
      console.log("timedDetect - Signature SDK Service not detected");
    }
  }*/

  onDetectRunning() {
    const ctrl = this;
    console.log("onDetectRunning - Signature SDK Service detected");
    const timeout = setTimeout(function () {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.running) {
        console.log("timedDetect - Signature SDK Service detected");
      }
      else {
        console.log("timedDetect - Signature SDK Service not detected");
      }
    }, 1500);
    clearTimeout(timeout);
  }



  restartSession(onRestartSession) {
    console.log("Restarting the session");
    this.wgssSignatureSDK = new WacomGSS_SignatureSDK(onRestartSession, 8000)
  }

  captureSignature() {
    let sigObj;
    let sigCtl;
    let dynCapt;
    const ctrl = this;

    function onPutSigData(sigObjV, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        console.log("PutSigData called");
      }
      else {
        console.log("error on PutSigData: " + status);
      }
    }

    function onGetSigText(sigObjV, data, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        console.log("SigText: " + data);
        var vData = new ctrl.wgssSignatureSDK.Variant();
        vData.type = ctrl.wgssSignatureSDK.VariantType.VARIANT_BASE64;
        vData.base64 = data;
        sigObjV.PutSigData(vData, onPutSigData);
      }
      else {
        console.log("error on GetSigData: " + status);
      }
    }

    function onGetAdditionalData(sigObjV, additionalData, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        console.log("Additional Data/MachineOS: " + additionalData);
        sigObjV.GetSigText(onGetSigText);
      }
      else {
        console.log("error on GetAdditionalData: " + status);
      }
    }

    function onRenderBitmap(sigObjV, bmpObj, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        if (bmpObj.isBase64) {
          console.log("Base64 bitmap retrieved:");
          console.log(bmpObj.image.src);
        }
        else {
          console.log("Bitmap retrieved, rendering image...");
        }
        ctrl.ctx.drawImage(bmpObj.image, 0, 0);
        sigObjV.GetAdditionalData(ctrl.wgssSignatureSDK.CaptData.CaptMachineOS, onGetAdditionalData);
        const base64 = (bmpObj.image.src).split(',');
        const contentBase64 = base64[1];
        ctrl.doc['contentBase64'] = contentBase64;
      }
      else {
        console.log("Signature Render Bitmap error: " + status);
      }
    }

    function onPutExtraData(sigObjV, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        console.log("Rendering bitmap");
        const flags = ctrl.wgssSignatureSDK.RBFlags.RenderOutputPicture | ctrl.wgssSignatureSDK.RBFlags.RenderColor24BPP;
        sigObjV.RenderBitmap("bmp", ctrl.canvas.width, ctrl.canvas.height, 0.7, 0x00000000, 0x00FFFFFF, flags, 0, 0, onRenderBitmap);
        sigObj = sigObjV;
      }
      else {
        console.log("Signature PutExtraData error: " + status);
      }
    }

    function onDynCaptCapture(dynCaptV, sigObjV, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        console.log("Adding extra data");
        sigObjV.PutExtraData("extra key", "extra value", onPutExtraData);
      }
      else if (1 === status) {
        console.log("Signature capture cancelled by the user");
      }
      else {
        console.log("Signature capture error: " + status);
      }
    }

    function onSigCtlPutLicence(sigCtlV, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        dynCapt.Capture(sigCtlV, " ", "Signature du bon " + ctrl.bon.numBon, null, null, onDynCaptCapture);
      }
      else {
        console.log("SigCtl constructor error: " + status);
      }
    }

    function onSigCtlConstructor(sigCtlV, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        sigCtlV.PutLicence(environment.LICENCEKEY_WACOM, onSigCtlPutLicence);
      }
      else {
        console.log("SigCtl constructor error: " + status);
      }
    }

    function onDynCaptConstructor(dynCaptV, status) {
      if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.ResponseStatus.OK === status) {
        sigCtl = ctrl.wgssSignatureSDK.SigCtl(onSigCtlConstructor);
      }
      else {
        console.log("Dynamic Capture constructor error: " + status);
        if (ctrl.wgssSignatureSDK.ResponseStatus.INVALID_SESSION === status) {
          ctrl.restartSession(ctrl.captureSignature);
        }
      }
    }

    if (ctrl.wgssSignatureSDK && ctrl.wgssSignatureSDK.running) {
      if (null == ctrl.canvas) {
        ctrl.canvas = document.getElementById("myCanvas");
        ctrl.ctx = ctrl.canvas.getContext("2d");
      }
      dynCapt = new ctrl.wgssSignatureSDK.DynamicCapture(onDynCaptConstructor);
    }
  }

  closeFunction() {
    this.isClicked = false;
    this.close.emit(this.isTiketPesee);
  }

  saveSignature() {
    if (!this.isClicked) {
      this.isClicked = true;
      if (this.doc['contentBase64']) {
        let promiseDocSignature: Promise<void | void[]> = this.addDoc();
        promiseDocSignature.then(datasPrint => {
          this.common.closeModal();
          this.validFunction.emit(this.isTiketPesee);
        });
      } else {
        this.common.closeModal();
        this.validFunction.emit(this.isTiketPesee);
      }
    }
  }

  addDoc() {
    if (this.listBon && this.listBon.length > 1) {
      const promises = this.listBon.map(bap => this.addDocBon(bap));
      return Promise.all(promises); 
    } else
      return this.addDocBon(this.bon);
  }

  addDocBon(b) {
    this.doc['clefObjetParent'] = b ? b['id'] : 0;
    this.doc['nomclass'] = 'FileObject';
    this.doc['nomFichier'] = 'Signature.png';
    this.doc['description'] = 'Signature ' + b.numBon;
    this.doc['nomFichierOriginal'] = 'Signature.png';
    let param = {
      'servlet': 'DBGestionDocBon',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'DOCUMENT': this.doc,
        'SIGNATURE': {
          'typeParam': 'boolean',
          'valeur': true
        }
      }
    };
    if (this.isBAP) {
      param = {
        'servlet': 'DBGestionDocBAP',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 1
          },
          'DOCUMENT': this.doc,
          'SIGNATURE': {
            'typeParam': 'boolean',
            'valeur': true
          }
        }
      };
    }

    return this.common.post('', { param: param }).then(data => {
      if (data) {
        this.doc['id'] = data;
        if (!b.documents)
          b.documents = [];
        b.documents.push(this.doc);
      }
    });
  }

}
